import Drawer from '@mui/material/Drawer';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import clsx from 'clsx';
import React, { useImperativeHandle, useState } from 'react';
import FusePageSimpleSidebarContent from './FusePageSimpleSidebarContent';

const FusePageSimpleSidebar = (props, ref) => {
	const [isOpen, setIsOpen] = useState(false);
	const { classes } = props;
	const theme = useTheme();
	const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
	const lgDown = useMediaQuery(theme.breakpoints.down('lg'));

	useImperativeHandle(ref, () => ({
		toggleSidebar: handleToggleDrawer,
	}));

	const handleToggleDrawer = () => {
		setIsOpen(!isOpen);
	};

	return (
		<>
			{(props.variant !== 'permanent' || !lgUp) && (
				<Drawer
					variant="temporary"
					anchor={props.position}
					open={isOpen}
					onClose={(_ev) => handleToggleDrawer()}
					classes={{
						root: clsx(classes.sidebarWrapper, props.variant),
						paper: clsx(
							classes.sidebar,
							props.variant,
							props.position === 'left' ? classes.leftSidebar : classes.rightSidebar,
						),
					}}
					ModalProps={{
						keepMounted: true, // Better open performance on mobile.
					}}
					container={props.rootRef.current}
					BackdropProps={{
						classes: {
							root: classes.backdrop,
						},
					}}
					style={{ position: 'absolute' }}
				>
					<FusePageSimpleSidebarContent {...props} />
				</Drawer>
			)}
			{props.variant === 'permanent' && lgUp && (
				<Drawer
					variant="permanent"
					className={clsx(classes.sidebarWrapper, props.variant)}
					open={isOpen}
					classes={{
						paper: clsx(
							classes.sidebar,
							props.variant,
							props.position === 'left' ? classes.leftSidebar : classes.rightSidebar,
						),
					}}
				>
					<FusePageSimpleSidebarContent {...props} />
				</Drawer>
			)}
		</>
	);
};

export default React.forwardRef(FusePageSimpleSidebar);
